import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';

var CalendarNav = /*#__PURE__*/function (_Vue) {
  _inherits(CalendarNav, _Vue);

  var _super = _createSuper(CalendarNav);

  function CalendarNav() {
    _classCallCheck(this, CalendarNav);

    return _super.apply(this, arguments);
  }

  _createClass(CalendarNav, [{
    key: "title",
    get: function get() {
      return "".concat(this.year).concat(this.month ? "/".concat("0".concat(Number(this.month)).slice(-2)) : '');
    }
  }]);

  return CalendarNav;
}(Vue);

__decorate([Prop({
  type: Boolean,
  default: function _default() {
    return false;
  }
})], CalendarNav.prototype, "isInPopover", void 0);

__decorate([Prop({
  type: Number,
  required: true
})], CalendarNav.prototype, "year", void 0);

__decorate([Prop({
  type: Number
})], CalendarNav.prototype, "month", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], CalendarNav.prototype, "isPrevDisable", void 0);

CalendarNav = __decorate([Component], CalendarNav);
export default CalendarNav;